export default __webpack_public_path__ + "fonts/mtp_ysujh_bn48vbg8snstqqynqkv_9plp7mupa0s4g-webfont.woff2";